import { render, staticRenderFns } from "./term-of-service.vue?vue&type=template&id=40f219fe"
import script from "./term-of-service.vue?vue&type=script&lang=js"
export * from "./term-of-service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports